import React, { useContext, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { UploadInput } from '@hero/components/molecules';
import { useValidationErrorsStore } from '@hero/components/providers/ValidationErrorsProvider';
import { ACCEPTED_IMAGES, VALIDATION_ERRORS } from '@hero/constants';

import { UPLOAD_LOGO_SCREEN } from './constants';
import { UploadLogoContext } from './context';

export default function UploadImage() {
  const { disabled, maxFiles, setIsOpen, setCropImage, setModalProps, setCurrentScreen } =
    useContext(UploadLogoContext);
  const { t } = useTranslation();
  const { addModalError, reset } = useValidationErrorsStore();

  const [status, setStatus] = useState('idle');

  const handleFile = async file => {
    setStatus('loading');
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      setCropImage(reader.result?.toString() || '');

      setTimeout(() => {
        setStatus('success');
      }, 1000);
    });
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    const primaryButtonProps = {
      children: t('next'),
      endIcon: 'next',
      onClick: () => {
        if (status === 'success') {
          setCurrentScreen(UPLOAD_LOGO_SCREEN.crop);
          reset();
        } else addModalError(<Trans i18nKey={VALIDATION_ERRORS.noLogoSelected} />);
      }
    };
    const secondaryButtonProps = {
      children: t('cancel'),
      onClick: () => {
        setStatus('idle');
        setModalProps(props => ({
          ...props,
          primaryButtonProps: {
            children: '',
            onClick: () => {
              setIsOpen(false);
            }
          },
          secondaryButtonProps: {
            children: ''
          }
        }));
      }
    };
    setModalProps(props => ({
      ...props,
      primaryButtonProps,
      secondaryButtonProps
    }));
  }, [status]);

  return (
    <UploadInput
      disabled={disabled}
      handleFile={handleFile}
      fileInformation={ACCEPTED_IMAGES}
      maxFiles={maxFiles}
      status={status}
      progressIntervalTime={10}
      instructions={[t('recommendedImgSize', { sizes: '400 x 400' })]}
    />
  );
}
